import {
  addWarehouseAreaApi,
  deleteWarehouseAreaApi,
  updateWarehouseAreaApi,
  queryWarehouseAreaApi,
  addWarehouseApi,
  deleteWarehouseApi,
  updateWarehouseApi,
  setWarehouseStateApi,
  getWarehouseByIdApi,
  queryWarehouseApi,
  addStockManageApi,
  inStockManageConfirmApi,
  outStockManageConfirmApi,
  getStockManageAndRelGoodsListByIdApi,
  queryStockManageApi,
  queryStockManageDetailedApi,
  queryGoodsSkuDetailForStockManageApi,
  setWarnInventoryApi,
  getUsableInStockDetailListApi,
  outStockPickingConfirmApi,
  outStockReturnPickingApi,
  outStockFinishApi,
  queryOutAndInStockSummaryApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加仓库区域信息
  async addWarehouseAreaAction(context, param) {
    const res = await addWarehouseAreaApi(param)
    return res
  },
  //  删除仓库区域信息
  async deleteWarehouseAreaAction(context, param) {
    const res = await deleteWarehouseAreaApi(param)
    return res
  },
  //  修改仓库区域信息
  async updateWarehouseAreaAction(context, param) {
    const res = await updateWarehouseAreaApi(param)
    return res
  },
  //  查询仓库区域列表信息
  async queryWarehouseAreaAction(context, param) {
    const res = await queryWarehouseAreaApi(param)
    return res
  },
  //  添加仓库
  async addWarehouseAction(context, param) {
    const res = await addWarehouseApi(param)
    return res
  },
  //  删除仓库
  async deleteWarehouseAction(context, param) {
    const res = await deleteWarehouseApi(param)
    return res
  },
  //  更新仓库
  async updateWarehouseAction(context, param) {
    const res = await updateWarehouseApi(param)
    return res
  },
  //  设置仓库状态
  async setWarehouseStateAction(context, param) {
    const res = await setWarehouseStateApi(param)
    return res
  },
  //  根据id获取仓库
  async getWarehouseByIdAction(context, param) {
    const res = await getWarehouseByIdApi(param)
    return res
  },
  //  查询仓库信息
  async queryWarehouseAction(context, param) {
    const res = await queryWarehouseApi(param)
    return res
  },
  //  添加商品库存管理信息
  async addStockManageAction(context, param) {
    const res = await addStockManageApi(param)
    return res
  },
  //  入库信息确认
  async inStockManageConfirmAction(context, param) {
    const res = await inStockManageConfirmApi(param)
    return res
  },
  //  出库信息确认
  async outStockManageConfirmAction(context, param) {
    const res = await outStockManageConfirmApi(param)
    return res
  },
  //  根据库存管理id获取库存管理信息关联商品列表
  async getStockManageAndRelGoodsListByIdAction(context, param) {
    const res = await getStockManageAndRelGoodsListByIdApi(param)
    return res
  },
  //  查询商品库存管理信息
  async queryStockManageAction(context, param) {
    const res = await queryStockManageApi(param)
    return res
  },
  //  查询商品库存管理信息明细
  async queryStockManageDetailedAction(context, param) {
    const res = await queryStockManageDetailedApi(param)
    return res
  },
  //  查询商品sku详情(用于库存管理)
  async queryGoodsSkuDetailForStockManageAction(context, param) {
    const res = await queryGoodsSkuDetailForStockManageApi(param)
    return res
  },
  //  设置预警库存
  async setWarnInventoryAction(context, param) {
    const res = await setWarnInventoryApi(param)
    return res
  },
  //  获取可用入库详情列表
  async getUsableInStockDetailListAction(context, param) {
    const res = await getUsableInStockDetailListApi(param)
    return res
  },
  //  出库捡货确认(扣减库存)
  async outStockPickingConfirmAction(context, param) {
    const res = await outStockPickingConfirmApi(param)
    return res
  },
  //  出库回退捡货
  async outStockReturnPickingAction(context, param) {
    const res = await outStockReturnPickingApi(param)
    return res
  },
  //  出库完成
  async outStockFinishAction(context, param) {
    const res = await outStockFinishApi(param)
    return res
  },
  //  查询出入库汇总
  async queryOutAndInStockSummaryAction(context, param) {
    const res = await queryOutAndInStockSummaryApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
